var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthorityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.35L14.125 14.975C14.225 15.0583 14.325 15.0625 14.425 14.9875C14.525 14.9125 14.5583 14.8167 14.525 14.7L13.7 12.05L15.925 10.3C16.0083 10.2167 16.0333 10.1208 16 10.0125C15.9667 9.90417 15.8917 9.85 15.775 9.85H13.1L12.25 7.175C12.2167 7.05833 12.1333 7 12 7C11.8667 7 11.7833 7.05833 11.75 7.175L10.9 9.85H8.225C8.10833 9.85 8.02917 9.90417 7.9875 10.0125C7.94583 10.1208 7.96667 10.2167 8.05 10.3L10.25 12.05L9.425 14.725C9.39167 14.8417 9.425 14.9375 9.525 15.0125C9.625 15.0875 9.725 15.0833 9.825 15L12 13.35ZM12 21.75C11.8833 21.75 11.775 21.7417 11.675 21.725C11.575 21.7083 11.475 21.6833 11.375 21.65C9.125 20.9 7.33333 19.5125 6 17.4875C4.66667 15.4625 4 13.2833 4 10.95V6.225C4 5.80833 4.12083 5.43333 4.3625 5.1C4.60417 4.76667 4.91667 4.525 5.3 4.375L11.3 2.125C11.5333 2.04167 11.7667 2 12 2C12.2333 2 12.4667 2.04167 12.7 2.125L18.7 4.375C19.0833 4.525 19.3958 4.76667 19.6375 5.1C19.8792 5.43333 20 5.80833 20 6.225V10.95C20 13.2833 19.3333 15.4625 18 17.4875C16.6667 19.5125 14.875 20.9 12.625 21.65C12.525 21.6833 12.425 21.7083 12.325 21.725C12.225 21.7417 12.1167 21.75 12 21.75ZM12 19.75C13.7333 19.2 15.1667 18.1 16.3 16.45C17.4333 14.8 18 12.9667 18 10.95V6.225L12 3.975L6 6.225V10.95C6 12.9667 6.56667 14.8 7.7 16.45C8.83333 18.1 10.2667 19.2 12 19.75Z",
    fill: "url(#paint0_linear_11757_124037)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11757_124037",
    x1: 4,
    y1: 11.875,
    x2: 20,
    y2: 11.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C987DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#BB54DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#A405D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorityIcon);
export default __webpack_public_path__ + "static/media/authority-icon.c8921f7c224b971d4796f375ee18ba72.svg";
export { ForwardRef as ReactComponent };